const salavirtual = {
  DescargarAudiencia: 'Forseti/SalaVirtual/DescargarAudiencia'  
}

const audienciasFinalizadas = {
  GetAudienciasFinalizadas: 'Forseti/AudienciasFinalizadas/GetAudienciasFinalizadas',
  GetAudienciaFinalizada: 'Forseti/AudienciasFinalizadas/GetAudienciaFinalizada',
  DescargaEvidencia: 'Forseti/AudienciasFinalizadas/DescargarEvidencia'
}

const consultas = {
  salavirtual: salavirtual,
  audienciasFinalizadas: audienciasFinalizadas
}

export default consultas;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/forseti/sistema/consultas/consultas.js
// module id = null
// module chunks = 